module.exports = __webpack_public_path__ + "img/yinhang@3x.7497b50c.png";